import axios from "axios";

// Set the base URL dynamically based on the environment
const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://ngowaters.com/api/users" // Production URL
    : "http://localhost:5000/api/users"; // Localhost URL

// Set Authorization header for authenticated requests
const setAuthHeader = () => {
  const token = localStorage.getItem("authToken"); // Ensure the same token name is used consistently
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  throw new Error("No token found. Please log in again.");
};

// Register user
export const registerUser = async (userData) => {
  try {
    const response = await axios.post(`${API_URL}/register`, userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error occurred during registration";
  }
};

// Login user
export const loginUser = async (email, password) => {
  try {
    const response = await axios.post(`${API_URL}/login`, { email, password });
    if (response.data.token) {
      localStorage.setItem("authToken", response.data.token); // Save token after successful login
    }
    return response.data;
  } catch (error) {
    console.error("Login error: ", error.response?.data);
    throw error.response?.data || "Error occurred during login";
  }
};

// Get user profile
export const getUserProfile = async () => {
  try {
    const response = await axios.get(`${API_URL}/profile`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      throw new Error("Session expired. Please log in again.");
    }
    throw error.response?.data || "Error occurred while fetching profile";
  }
};

// Update user profile
export const updateUserProfile = async (formData) => {
  try {
    const response = await axios.put(`${API_URL}/profile`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...setAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");
      throw new Error("Session expired. Please log in again.");
    }
    throw error.response?.data || "Error occurred during profile update";
  }
};
